import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  selectItem,
  setReportType,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  cleanQuickFilter,
  deleteItemRequest,
  deleteItemSuccess,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setQuickFilterParams,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const setActiveTab = createAction('setActiveTab');
const setActivePage = createAction('setActivePage');
const getCarrierSuccess = createAction('getCarrierSuccess');
const setTerminalDetails = createAction('setTerminalDetails');
const createWatchRequest = createAction('createWatchRequest');
const changeBranchRequest = createAction('changeBranchRequest');
const createCarrierRequest = createAction('createCarrierRequest');
const startCarrierInsurances = createAction('startCarrierInsurances');
const createCarrierRefRequest = createAction('createCarrierRefRequest');
const addCarriersToWatchListRequest = createAction('addCarriersToWatchListRequest');
const createSendOnboardingPackageRequest = createAction('createSendOnboardingPackageRequest');
const getCarrierStatisticReportDataRequest = createAction('getCarrierStatisticReportDataRequest');
const addCarriersToWatchListByReportRequest = createAction('addCarriersToWatchListByReportRequest');
const getCarrierRateRequestReportDataRequest = createAction('getCarrierRateRequestReportDataRequest');
const receivedCarrierOnboardingPackageSuccess = createAction('receivedCarrierOnboardingPackageSuccess');
const createCarrierSaferWatchMassUpdateRequest = createAction('createCarrierSaferWatchMassUpdateRequest');
const createCarrierSaferWatchMassUpdateByReportRequest =
  createAction('createCarrierSaferWatchMassUpdateByReportRequest');
// trucker tools
const addToNetworkCarriersRequest = createAction('addToNetworkCarriersRequest');
const allowBookItNowCarriersRequest = createAction('allowBookItNowCarriersRequest');
const forbidBookItNowCarriersRequest = createAction('forbidBookItNowCarriersRequest');
const removeFromNetworkCarriersRequest = createAction('removeFromNetworkCarriersRequest');
const addToNetworkCarriersByReportRequest = createAction('addToNetworkCarriersByReportRequest');
const allowBookItNowCarriersByReportRequest = createAction('allowBookItNowCarriersByReportRequest');
// carrier synchronization
const syncCarrierListRequest = createAction('syncCarrierListRequest');
const syncCarrierByReportRequest = createAction('syncCarrierByReportRequest');
const addOrRemoveCarrierWatchRequest = createAction('addOrRemoveCarrierWatchRequest');
const addSyncCarriersToWatchListRequest = createAction('addSyncCarriersToWatchListRequest');
const addSyncCarriersToWatchListByReportRequest = createAction('addSyncCarriersToWatchListByReportRequest');
// carrier integration
const sendCarrierListToIntegrationRequest = createAction('sendCarrierListToIntegrationRequest');
const sendCarrierListToIntegrationSuccess = createAction('sendCarrierListToIntegrationSuccess');
// carrier tracking synchronization
const changeTrackingIntegrationStatusRequest = createAction('changeTrackingIntegrationStatusRequest');
const getDispatchIntegrationConfigListRequest = createAction('getDispatchIntegrationConfigListRequest');
const getDispatchIntegrationConfigListSuccess = createAction('getDispatchIntegrationConfigListSuccess');
const addCarrierListToTrackingWishListRequest = createAction('addCarrierListToTrackingWishListRequest');

export {
  // report
  setReports,
  selectItem,
  // report
  setActiveTab,
  setReportType,
  setUsedReport,
  setActivePage,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  cleanQuickFilter,
  deleteItemRequest,
  deleteItemSuccess,
  setTableTitleSort,
  getCarrierSuccess,
  getItemListRequest,
  getItemListSuccess,
  setTerminalDetails,
  createWatchRequest,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  changeBranchRequest,
  setQuickFilterParams,
  createCarrierRequest,
  setIgnorePromptStatus,
  resetListAndPagination,
  startCarrierInsurances,
  // carrier synchronization
  syncCarrierListRequest,
  exportReportDataRequest,
  createCarrierRefRequest,
  setInitialStateOmitReport,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  syncCarrierByReportRequest,
  // trucker tools
  addToNetworkCarriersRequest,
  addCarriersToWatchListRequest,
  allowBookItNowCarriersRequest,
  forbidBookItNowCarriersRequest,
  addOrRemoveCarrierWatchRequest,
  removeFromNetworkCarriersRequest,
  addSyncCarriersToWatchListRequest,
  createSendOnboardingPackageRequest,
  addToNetworkCarriersByReportRequest,
  // carrier integration
  sendCarrierListToIntegrationRequest,
  sendCarrierListToIntegrationSuccess,
  getCarrierStatisticReportDataRequest,
  addCarriersToWatchListByReportRequest,
  allowBookItNowCarriersByReportRequest,
  getCarrierRateRequestReportDataRequest,
  receivedCarrierOnboardingPackageSuccess,
  // carrier tracking synchronization
  changeTrackingIntegrationStatusRequest,
  addCarrierListToTrackingWishListRequest,
  getDispatchIntegrationConfigListRequest,
  getDispatchIntegrationConfigListSuccess,
  createCarrierSaferWatchMassUpdateRequest,
  addSyncCarriersToWatchListByReportRequest,
  createCarrierSaferWatchMassUpdateByReportRequest,
};
